// The Custom Gift tab's first step - "what would you like to send?" - 4
// cards matching the reference exactly. "Choose from Gallery" reuses
// SendGiftScreen.tsx's existing file input unchanged (all its validation
// stays as-is); the other 3 open a dedicated capture view.
export function PrivateDropMediaSourcePicker({
  onTakePhoto,
  onRecordVideo,
  onChooseFromGallery,
  onVoiceDrop,
}: {
  onTakePhoto: () => void;
  onRecordVideo: () => void;
  onChooseFromGallery: () => void;
  onVoiceDrop: () => void;
}) {
  return (
    <div className="private-drop-source-picker">
      <span className="send-gift-section-label">What would you like to send?</span>
      <div className="private-drop-source-cards">
        <button type="button" className="private-drop-source-card" onClick={onTakePhoto}>
          <span className="private-drop-source-card-icon">
            <i className="bi bi-camera-fill" aria-hidden="true" />
          </span>
          <span className="private-drop-source-card-body">
            <span className="private-drop-source-card-title">Take Photo</span>
            <span className="private-drop-source-card-subtitle">Capture something now</span>
          </span>
        </button>
        <button type="button" className="private-drop-source-card" onClick={onRecordVideo}>
          <span className="private-drop-source-card-icon">
            <i className="bi bi-camera-video-fill" aria-hidden="true" />
          </span>
          <span className="private-drop-source-card-body">
            <span className="private-drop-source-card-title">Record Video</span>
            <span className="private-drop-source-card-subtitle">Record a video for them</span>
          </span>
        </button>
        <button type="button" className="private-drop-source-card" onClick={onChooseFromGallery}>
          <span className="private-drop-source-card-icon">
            <i className="bi bi-image-fill" aria-hidden="true" />
          </span>
          <span className="private-drop-source-card-body">
            <span className="private-drop-source-card-title">Choose from Gallery</span>
            <span className="private-drop-source-card-subtitle">Pick a photo or video</span>
          </span>
        </button>
        <button type="button" className="private-drop-source-card" onClick={onVoiceDrop}>
          <span className="private-drop-source-card-icon">
            <i className="bi bi-mic-fill" aria-hidden="true" />
          </span>
          <span className="private-drop-source-card-body">
            <span className="private-drop-source-card-title">Voice Drop</span>
            <span className="private-drop-source-card-subtitle">Send a private voice message</span>
          </span>
        </button>
      </div>
      <p className="private-drop-source-footer">
        <i className="bi bi-lock-fill" aria-hidden="true" /> All drops are private and secure.
      </p>
    </div>
  );
}
